import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ButtonComponent } from 'src/app/shared/reusable/button/button.component';

@Component({
  selector: 'app-crediflow-layout',
  templateUrl: './crediflow-layout.component.html',
  styleUrls: ['./crediflow-layout.component.scss'],
  standalone: true,
  imports: [ButtonComponent, CommonModule],
})
export class CrediflowLayoutComponent {
  showTyC = false;
  showLinks = false;

  closeTyC(): void {
    this.showTyC = false;
  }

  openTyC(): void {
    this.showTyC = true;
  }

  closeFooter(): void {
    this.showLinks = false;
  }

  openFooter(): void {
    this.showLinks = true;
  }
}
